/* src/app/modules_v2/investment/investment-asset-shared/components/investment-asset-detail/investment-asset-detail.component.scss */
:host {
  display: block;
}
.iad-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.iad-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.iad-card__header,
.iad-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.iad-block__header {
  margin-bottom: 8px;
}
.iad-card__title,
.iad-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
  min-width: 0;
}
.iad-card__title mat-icon,
.iad-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
  flex-shrink: 0;
}
.iad-block__count {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.iad-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.iad-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.iad-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.iad-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.iad-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.iad-kpis--compact {
  margin-top: 8px;
}
.iad-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.iad-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.iad-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.iad-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.iad-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.iad-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.iad-line + .iad-line {
  border-top: 1px solid #eef1f4;
}
.iad-line__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.iad-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.iad-block {
  padding: 10px 0;
}
.iad-block + .iad-block {
  border-top: 1px solid #eef1f4;
}
.iad-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.iad-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.iad-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.iad-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.iad-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.iad-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.iad-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.iad-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.iad-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.iad-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.iad-move__concept,
.iad-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iad-move__concept {
  color: #2f3540;
}
.iad-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.iad-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.iad-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.iad-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.iad-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.iad-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.iad-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.iad-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.iad-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.iad-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.iad-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.iad-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.iad-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.iad-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .iad-panel {
    grid-template-columns: 1fr;
  }
  .iad-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .iad-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .iad-move__date {
    grid-column: 1/-1;
  }
}
.iad-actions {
  gap: 8px;
  flex-wrap: wrap;
}
.iad-move--schedule {
  grid-template-columns: minmax(0, 1fr) auto;
}
.iad-kpi__hint {
  font-size: 11px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
/*# sourceMappingURL=investment-asset-detail.component.css.map */
